
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-d2be4b8a!sass-loader?sourceMap!./stylesheets/app.scss")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/app.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-d2be4b8a!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/app.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/App.vue
// module id = 588
// module chunks = 1